import { useAuthStore } from '../store/auth.store';
import { useOrganizationStore } from '../store/organization.store';
import { useUserStore } from '../store/user.store';
import { useChatStore } from '../store/chat.store';
import { useInvoiceStore } from '../store/invoice.store';
import { useNotificationStore } from '../store/notification.store';
import { useReportStore } from '../store/report.store';
import { useUploadStore } from '../store/upload.store';

/**
 * Centralized function to clear all user data and reset application state
 * Used for both manual logout and token expiration
 */
export const clearAllUserData = () => {
  // Clear all localStorage items related to authentication and user session
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
  localStorage.removeItem('expirationTime');
  localStorage.removeItem('selectedOrg');
  
  // Reset auth store
  useAuthStore.setState({
    user: null,
    accessToken: null,
    refreshToken: null,
    isLoading: false,
    error: null,
    isAuthenticated: false,
    isInitialized: true,
    isAppBootstrapping: false,
  });

  // Reset all other stores
  resetAllStores();
};

/**
 * Reset all non-auth Zustand stores to their initial state
 */
const resetAllStores = () => {
  // Reset organization store
  useOrganizationStore.setState({
    organizations: [],
    organization: null,
    isLoading: false,
    error: null
  });

  // Reset user store
  useUserStore.setState({
    users: [],
    isLoading: false,
    error: null,
    currentUser: null
  });

  // Reset chat store
  useChatStore.setState({
    messages: [],
    isLoading: false,
    error: null,
    pinnedMessages: [],
    isLoadingPinned: false,
    pinInFlightId: null,
  });

  // Reset invoice store
  useInvoiceStore.setState({
    invoices: [],
    currentFolderId: undefined,
    currentFolderPath: [],
    allFolders: [],
    searchResults: null,
    isLoading: false,
    isContentLoading: false,
    isSearching: false,
    error: null
  });

  // Reset notification store
  useNotificationStore.setState({
    notifications: [],
    unreadCount: 0,
    isLoading: false,
    error: null,
    hasMore: false,
    totalCount: 0
  });

  // Reset report store
  useReportStore.setState({
    reports: [],
    report: null,
    isLoading: false,
    error: null
  });

  // Reset upload store
  useUploadStore.setState({
    uploadedFile: null,
    isUploading: false,
    error: null
  });
};

/**
 * Perform complete logout and redirect to login page
 */
export const performLogout = () => {
  clearAllUserData();
  window.location.href = "/login";
};

